export interface ReadOnlyOptions {
  // [[包含的角色], [排除的角色]]
  roles: string[][]
  // [[包含的dataCode], [排除的dataCode]]
  fields?: string[][]
}

/**
 * ro: {
 *   roles: [["包含的角色"], ["排除的角色"]],
 *   fields: [["包含的dataCode"], ["排除的dataCode"]]
 * }
 * 例: 允许 CALL_CENTER 角色用户填写表单
 * {
 *   roles: [[], ["CALL_CENTER"]]
 * }
 */

// 解析字段配置项 ro 字段只读
export function resolveRO(item: any): true | undefined {

  if (typeof item.ro === 'undefined') {
    return
  }

  const options: true | ReadOnlyOptions = item.ro

  if (options === true) {
    return true
  }

  const role = sessionStorage.roleCode || ""
  const [includeRoles, excludeRoles] = options.roles || []

  if (Array.isArray(includeRoles) && includeRoles.length > 0) {
    // 不在禁用角色中则不禁用
    if (!includeRoles.includes(role)) {
      return
    }
    // 没有配置排除禁用角色
    if (excludeRoles.length === 0 && !Array.isArray(options.fields)) {
      return true
    }
  }

  if (Array.isArray(excludeRoles) && excludeRoles.length > 0) {
    // 在排除的角色中则不禁用
    if (excludeRoles.includes(role)) {
      // 没有配置
      if (!Array.isArray(options.fields)) {
        return
      }
    }
  }

  // 未配置字段规则 默认为禁用
  if (!Array.isArray(options.fields)) {
    return true
  }

  const [includeFields, excludeFields] = options.fields || []

  // 
  if (Array.isArray(includeFields) && includeFields.length > 0) {
    if (includeFields.includes(item.dataCode)) {
      return true
    }
  }

  if (Array.isArray(excludeFields) && excludeFields.length > 0) {
    if (!excludeFields.includes(item.dataCode)) {
      return true
    }
  }
}

export function fieldRO(item: any) {
  const value = resolveRO(item)
  // 组件上formIsRead 为false时才是禁用!!!!
  if (value === true) {
    return false
  }
}